import _ from 'lodash';

function initializeCustomFilters(scope) {
    // ** START CUSTOM FILTERS **
    scope.activityStatusFilter = {
        displayKey: 'gateway.views.activities-landing.Status',
        displayValue: '',
        options: [{
            code: 'open',
            displayKey: 'gateway.views.activities-landing.Open',
            displayValue: '',
            selected: false
        }, {
            code: 'complete',
            displayKey: 'gateway.views.activities-landing.Complete',
            displayValue: '',
            selected: false
        }, {
            code: 'canceled',
            displayKey: 'gateway.views.activities-landing.Canceled',
            displayValue: '',
            selected: false
        }, {
            code: 'skipped',
            displayKey: 'gateway.views.activities-landing.Skipped',
            displayValue: '',
            selected: false
        }]
    };

    scope.activityTypeFilter = {
        displayKey: 'gateway.views.activities-landing.Type',
        displayValue: '',
        options: []
    };

    scope.activityPriorityFilter = {
        displayKey: 'gateway.views.activities-landing.Priority',
        displayValue: '',
        options: []
    };

    scope.activityAssignmentFilter = {
        displayKey: 'gateway.views.activities-landing.Assignment',
        displayValue: '',
        options: [{
            code: 'assignedToMe',
            displayKey: 'gateway.views.activities-landing.To Me',
            displayValue: '',
            selected: false
        }, {
            code: 'assignedToOthers',
            displayKey: 'gateway.views.activities-landing.To Others',
            displayValue: '',
            selected: false
        }]
    };

    scope.activityCreatedByFilter = {
        displayKey: 'gateway.views.activities-landing.Created By',
        displayValue: '',
        options: [{
            code: 'createdByMe',
            displayKey: 'gateway.views.activities-landing.Me',
            displayValue: '',
            selected: false
        }, {
            code: 'createdByOthers',
            displayKey: 'gateway.views.activities-landing.Others',
            displayValue: '',
            selected: false
        }]
    };

    scope.customFilter = {
        filters: [scope.activityStatusFilter,
            scope.activityTypeFilter,
            scope.activityPriorityFilter,
            scope.activityAssignmentFilter,
            scope.activityCreatedByFilter
        ]
    };
    // ** END CUSTOM FILTERS **
}

function initializeQuickFilters(scope) {
    // ** START QUICK FILTERS **
    scope.myOpenFilter = {
        name: 'myOpenActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.Your Open'
    };
    scope.myClosedFilter = {
        name: 'myClosedActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.Your Completed'
    };
    scope.createdByMeFilter = {
        name: 'createdByMeActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.Created By You'
    };
    scope.allOpenFilter = {
        name: 'allOpenActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.All Open'
    };
    scope.allClosedFilter = {
        name: 'allClosedActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.All Completed'
    };
    scope.allCanceledFilter = {
        name: 'allCanceledActivities',
        displayValue: '',
        displayKey: 'gateway.views.activities-landing.All Canceled'
    };
    // ** END QUICK FILTERS **
}

function translateFilters(scope, translateFunction) {
    scope.translationObjects = [
        scope.activityStatusFilter,
        scope.activityStatusFilter.options[0],
        scope.activityStatusFilter.options[1],
        scope.activityStatusFilter.options[2],
        scope.activityStatusFilter.options[3],
        scope.activityTypeFilter,
        scope.activityPriorityFilter,
        scope.activityAssignmentFilter,
        scope.activityAssignmentFilter.options[0],
        scope.activityAssignmentFilter.options[1],
        scope.activityCreatedByFilter,
        scope.activityCreatedByFilter.options[0],
        scope.activityCreatedByFilter.options[1],
        scope.myOpenFilter,
        scope.myClosedFilter,
        scope.createdByMeFilter,
        scope.allOpenFilter,
        scope.allClosedFilter,
        scope.allCanceledFilter
    ];

    translateFunction(scope.translationObjects);
}

/**
 * Set the status of the active quick filters
 * @param {scope} scope
 */
function setActiveQuickFilter(scope) {
    scope.myOpenFilterActive = (scope.currentQuickFilter === scope.myOpenFilter);
    scope.myClosedFilterActive = (scope.currentQuickFilter === scope.myClosedFilter);
    scope.createdByMeFilterActive = (scope.currentQuickFilter === scope.createdByMeFilter);
    scope.allOpenFilterActive = (scope.currentQuickFilter === scope.allOpenFilter);
    scope.allClosedFilterActive = (scope.currentQuickFilter === scope.allClosedFilter);
    scope.allCanceledFilterActive = (scope.currentQuickFilter === scope.allCanceledFilter);
}

/**
 * Set the custom filter sub options to true for the current quick filter
 * @param {scope} scope
 * @param {*} quickFilter
 */
function setCustomFilterFieldsForQuickFilter(scope, quickFilter) {
    if (angular.isDefined(quickFilter) && quickFilter !== null) {
        setCustomFiltersSelected(scope.customFilter, false);
        switch (quickFilter) {
            case scope.myOpenFilter:
                const openOptionMyOpenFilter = _.find(scope.activityStatusFilter.options, (option) => {
                    return option.code === 'open';
                });
                openOptionMyOpenFilter.selected = true;

                const assignedToMeOptionMyOpenFilter = _.find(scope.activityAssignmentFilter.options, (option) => {
                    return option.code === 'assignedToMe';
                });
                assignedToMeOptionMyOpenFilter.selected = true;
                break;
            case scope.myClosedFilter:
                const completeOptionMyClosedFilter = _.find(scope.activityStatusFilter.options, (option) => {
                    return option.code === 'complete';
                });
                completeOptionMyClosedFilter.selected = true;

                const assignedToMeOption = _.find(scope.activityAssignmentFilter.options, (option) => {
                    return option.code === 'assignedToMe';
                });
                assignedToMeOption.selected = true;
                break;
            case scope.createdByMeFilter:
                const createdByMeOption = _.find(scope.activityCreatedByFilter.options, (option) => {
                    return option.code === 'createdByMe';
                });
                createdByMeOption.selected = true;

                setAllFilterOptionsSelected(scope.activityStatusFilter, true);
                break;
            case scope.allOpenFilter:
                const openOption = _.find(scope.activityStatusFilter.options, (option) => {
                    return option.code === 'open';
                });
                openOption.selected = true;

                setAllFilterOptionsSelected(scope.activityAssignmentFilter, true);
                break;
            case scope.allClosedFilter:
                const completeOption = _.find(scope.activityStatusFilter.options, (option) => {
                    return option.code === 'complete';
                });
                completeOption.selected = true;

                setAllFilterOptionsSelected(scope.activityAssignmentFilter, true);
                break;
            case scope.allCanceledFilter:
                const canceledOption = _.find(scope.activityStatusFilter.options, (option) => {
                    return option.code === 'canceled';
                });
                canceledOption.selected = true;

                setAllFilterOptionsSelected(scope.activityAssignmentFilter, true);
                break;
            default:
                break;
        }
    }
}

function setCustomFiltersSelected(customFilter, value) {
    customFilter.filters.forEach((filter) => {
        setAllFilterOptionsSelected(filter, value);
    });
}

function setAllFilterOptionsSelected(customFilter, value) {
    customFilter.options.forEach((option) => {
        option.selected = value;
    });
}

function createActivityStatusFilterOptions(scope, activity) {
    if (
        _.filter(scope.activityStatusFilter.options, {
            code: activity.status
        }).length === 0) {
        const newFilter = {
            code: activity.status,
            displayKey: activity.status,
            displayValue: activity.status,
            selected: false
        };
        scope.activityStatusFilter.options.push(newFilter);
    }
}

function createActivityTypeFilterOptions(scope, activity) {
    if (activity.activityPattern.category &&
        _.filter(scope.activityTypeFilter.options, {
            code: activity.activityPattern.category.code
        }).length === 0) {
        const newFilter = {
            code: activity.activityPattern.category.code,
            displayKey: activity.activityPattern.category.name,
            displayValue: activity.activityPattern.category.name,
            selected: false
        };
        scope.activityTypeFilter.options.push(newFilter);
    }
}

function createActivityPriorityFilterOptions(scope, priorityTypeList) {
    const priorityOptions = [];
    for (const code in priorityTypeList.codes) {
        if (priorityTypeList.codes.hasOwnProperty(code)) {
            const newFilter = {
                code: priorityTypeList.codes[code].code,
                displayKey: priorityTypeList.codes[code].displayKey,
                displayValue: priorityTypeList.codes[code].name,
                selected: false,
                priority: priorityTypeList.codes[code].priority
            };
            priorityOptions.push(newFilter);
        }
    }
    scope.activityPriorityFilter.options = priorityOptions.sort((priorityA, priorityB) => {
        if (priorityA.priority > priorityB.priority) {
            return 1;
        } else if (priorityA.priority < priorityB.priority) {
            return -1;
        }

        return 0;
    });
}

function setQuickFilterActivityValues(scope) {
    scope.myClosedFilterValue = scope.getFilteredActivities(scope.myClosedFilter).length;
    scope.createdByMeFilterValue = scope.getFilteredActivities(scope.createdByMeFilter).length;
    scope.allOpenFilterValue = scope.getFilteredActivities(scope.allOpenFilter).length;
    scope.allClosedFilterValue = scope.getFilteredActivities(scope.allClosedFilter).length;
    scope.allCanceledFilterValue = scope.getFilteredActivities(scope.allCanceledFilter).length;
    scope.myOpenFilterValue = scope.getFilteredActivities(scope.myOpenFilter).length;
}

export default {
    'initializeCustomFilters': (scope) => {
        return initializeCustomFilters(scope);
    },

    'initializeQuickFilters': (scope) => {
        return initializeQuickFilters(scope);
    },

    'translateFilters': (scope, translateFunction) => {
        return translateFilters(scope, translateFunction);
    },
    'setActiveQuickFilter': (scope) => {
        return setActiveQuickFilter(scope);
    },
    'setCustomFilterFieldsForQuickFilter': (scope, filter) => {
        return setCustomFilterFieldsForQuickFilter(scope, filter);
    },
    'createActivityStatusFilterOptions': (scope, activity) => {
        return createActivityStatusFilterOptions(scope, activity);
    },
    'createActivityTypeFilterOptions': (scope, activity) => {
        return createActivityTypeFilterOptions(scope, activity);
    },
    'createActivityPriorityFilterOptions': (scope, priorityTypeList) => {
        return createActivityPriorityFilterOptions(scope, priorityTypeList);
    },
    'setQuickFilterActivityValues': (scope) => {
        return setQuickFilterActivityValues(scope);
    },
    'setCustomFiltersSelected': (customFilter, value) => {
        return setCustomFiltersSelected(customFilter, value);
    }
};